export default {
  process: {
    step1: 'パズル設定',
    step2: 'ゲームプレイ設定',
    next: '次へ',
    previous: '前へ',
    finish: '完了',
  },
  step1: {
    setting1: {
      title: '下の画像',
      upload: 'ベース画像をアップロードしてください。',
    },
    setting2: {
      title: 'パズルピース',
      blockNum: 'ブロック数',
      style: 'パズルのスタイル',
      edgeStyle: '縫い目のスタイル',
    },
    setting3: {
      title: '詳細設定',
      border: '輪郭',
      innerShadow: 'インナーシャドウ',
      relief: 'エンボス',
      solidLine: '実線',
      dashLine: '破線',
      lineWidth: '太さ',
      solidSegment: '破線',
      blankSegment: '間隔',
      blur: 'ぼかし',
      topShadow: 'ハイライトカラー',
      bottomShadow: 'シャドーカラー',
    },
  },
  step2: {
    title: '特定のゲームプレイのパズルピース',
    titleTip:
      '特殊なゲームプレイのパズルピースを選択し、キャンバスでパズルピースを選んで対応する特殊なロジックを割り当てます。',
    addSpePuzzle: '特定ピースを追加',
    preview: 'プレビューのスタイル',
    closePreview: 'プレビューを閉じる',
    name: '名前',
    placeholder: '入力',
    nameEmptyWarning: '名前は空白にできません',
    puzzleColor: 'パズルの色',
    lightBorder: '発光ストローク',
    lightInnerShadow: '発光インナーシャドウ',
    blur: 'ぼかし',
  },
}
